/*
 * @Description:集团相关
 * @Author: WangYuhan
 * @Date: 2022-12-26 16:04:45
 * @LastEditTime: 2025-04-29 16:08:35
 * @LastEditors: didan
 */

import { get, post, prefix, prefixShipper } from './base';

// 集团信息
export function getGroups(params) {
  return get(`${prefix}group`, params);
}
// 获取集团开通的网货列表
export function getChannelInfoList(params) {
  return get(`${prefix}channelInfo/group`, params);
}

// 查看企业是否开通万金油
export function groupCheckWanJinYou(params) {
  return get(`${prefix}wanjinyou/groupCheckWanJinYou`, params);
}

// 跳转万金油
export function linkWanJinYou(params) {
  return get(`${prefix}wanjinyou/linkWanJinYou`, params);
}

// 跳转八爪鱼
export function bzyLogin(params) {
  return get(`${prefix}bzyLogin`, params);
}

// 查询当前企业选择的网货平台
export function findChannelInfoByCorp(params) {
  return get(`${prefix}waybillSettlement/findChannelInfoByCorp`, params);
}
//获取所有网货账户
export function findChannelInfoAndChannelAccountByCorp(params) {
  return get(`${prefix}waybillSettlement/findChannelInfoAndChannelAccountByCorp`, params);
}
//  获取高德key
export function getKeys() {
  return get(`${prefix}config/amap/configration`);
}

// 高德poi-关键字搜索
export function getInputPoiPlace(params) {
  return get(`${prefix}common/poi/place`, params);
}

// 高德poi-经纬度搜索
export function getRegeoPoiAreaInfo(params) {
  return get(`${prefix}vehicleTraj/getRegeoPoiAreaInfo`, params);
}

/* 新轨迹查询 */
export function getVehicleTrajectory(params) {
  return get(`${prefix}sinoiov/trajectory/getVehicleTrajectory`, params);
}

/**
 * @description: 万金油相关
 */
export function checkWanJinYou(corpId, params) {
  return get(`${prefix}wanjinyou/checkWanJinYou/${corpId}`, params);
}

/**
 * @description: 公共筛选项列表查询
 * @author: lijinpeng
 */

// 根据企业ID查询项目列表
export function getProjectListByBid(params) {
  return get(`${prefix}project/group/business/projectList`, params);
}

// 根据企业ID查询线路列表
export function getRouteListByBid(params) {
  return get(`${prefix}routeInfo/group/business/project/list`, params);
}

// 修改企业名称及企业icon
export function updateGroup(params) {
  return post(`${prefix}group/update`, params);
}

// 获取企业的补贴油款配置
export function getOilConfigByBusinessId(params) {
  return get(`${prefix}oil/getOilConfigByBusinessId`, params);
}

// 获取集团的配置列表（集团和企业）
export function getAllByGroupId(params) {
  return get(`${prefix}setting/getAllByGroupId`, params);
}

//修改字段-详情
export function configurationDetail(params) {
  return get(`${prefix}/configuration/detail`, params);
}

//判断是否在白名单
export function checkAppWhiteList(params) {
  return post(`${prefix}api/driver-unified/outer/checkAppWhiteList`, params);
}

// 判断智能录单路由是否展示
export function checkSmartOrder(params) {
  return get(`${prefix}/api/ai/waybill/aiCorporationWhiteList?businessId=${params.businessId}`);
}
// 获取公钥
export function getPubKey() {
  return get(`${prefix}user/common/secret/getPubKey`);
}

// 获取广告列表
export function getAdsList(params) {
  return get(`${prefixShipper}ads/query`, params);
}
